































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { UserProfile } from '@/models/user-profile';
import UserFollowWidget from '@/components/UserFollowWidget.vue';
import UserAvatar from '@/components/UserAvatar.vue';

const numeral = require('numeraljs');

@Component({ components: { UserAvatar, UserFollowWidget } })
export default class UserProfileCard extends Vue {
  @Prop(UserProfile) public user!: UserProfile;

  get numFollowers() {
    return numeral(this.user.numFollowers).format('0a');
  }
  get numFollowing() {
    return numeral(this.user.numFollowing).format('0a');
  }
}
